import React from "react";

const NoSubscription = (props: any) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M50.0006 94.7923C46.7506 94.7923 43.584 93.1256 41.4173 90.209L37.209 84.584C36.334 83.4173 35.1673 82.7506 33.9173 82.6673C32.6673 82.6256 31.4173 83.1673 30.4173 84.209L28.0423 82.084L30.334 84.209C24.334 90.6256 19.709 90.1256 17.5006 89.2506C15.2506 88.3756 11.459 85.5006 11.459 76.2506V29.334C11.459 10.834 16.7923 5.20898 34.2507 5.20898H65.7506C83.209 5.20898 88.5423 10.834 88.5423 29.334V76.2506C88.5423 85.459 84.7506 88.334 82.5006 89.2506C80.2923 90.1256 75.709 90.6256 69.6673 84.209C68.6673 83.1256 67.4173 82.5423 66.1256 82.6673C64.8756 82.7506 63.6673 83.4173 62.7923 84.584L58.584 90.209C56.4173 93.1256 53.2506 94.7923 50.0006 94.7923ZM33.6673 76.3756C33.834 76.3756 34.0423 76.3756 34.209 76.3756C37.2923 76.5423 40.209 78.1673 42.1673 80.7923L46.3756 86.4173C48.4173 89.1256 51.5423 89.1256 53.584 86.4173L57.7923 80.7923C59.7923 78.1673 62.6673 76.5423 65.7923 76.3756C68.8756 76.209 71.959 77.5006 74.209 79.9173C77.3756 83.2923 79.4173 83.709 80.1673 83.4173C81.1673 83.0006 82.2506 80.584 82.2506 76.2506V29.334C82.2506 14.2923 79.6256 11.459 65.709 11.459H34.2507C20.334 11.459 17.709 14.2923 17.709 29.334V76.2506C17.709 80.6256 18.7923 83.0423 19.7923 83.4173C20.5007 83.709 22.584 83.2923 25.7506 79.9173C28.0007 77.6256 30.7923 76.3756 33.6673 76.3756Z"
        fill="var(--color-stroke-active)"
      />
      <path
        d="M67.6257 48.959H44.709C43.0007 48.959 41.584 47.5423 41.584 45.834C41.584 44.1257 43.0007 42.709 44.709 42.709H67.6257C69.334 42.709 70.7507 44.1257 70.7507 45.834C70.7507 47.5423 69.334 48.959 67.6257 48.959Z"
        fill="var(--color-stroke-active)"
      />
      <path
        d="M67.6257 32.291H44.709C43.0007 32.291 41.584 30.8744 41.584 29.166C41.584 27.4577 43.0007 26.041 44.709 26.041H67.6257C69.334 26.041 70.7507 27.4577 70.7507 29.166C70.7507 30.8744 69.334 32.291 67.6257 32.291Z"
        fill="var(--color-stroke-active)"
      />
      <path
        d="M32.4167 33.3333C30.125 33.3333 28.25 31.4583 28.25 29.1667C28.25 26.875 30.125 25 32.4167 25C34.7083 25 36.5833 26.875 36.5833 29.1667C36.5833 31.4583 34.7083 33.3333 32.4167 33.3333Z"
        fill="var(--color-stroke-active)"
      />
      <path
        d="M32.4167 49.9993C30.125 49.9993 28.25 48.1243 28.25 45.8327C28.25 43.541 30.125 41.666 32.4167 41.666C34.7083 41.666 36.5833 43.541 36.5833 45.8327C36.5833 48.1243 34.7083 49.9993 32.4167 49.9993Z"
        fill="var(--color-stroke-active)"
      />
    </svg>
  );
};

export default NoSubscription;
